"use strict";
import { gsap, Power3 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import TweenMax from "gsap";
import Swiper, { Navigation, Pagination, Autoplay } from "swiper/swiper-bundle";
import smoothscroll from "smoothscroll-polyfill";
import * as lock from "./_scrollLock";
import SimpleBar from "simplebar";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

// header scroll (smp)
// - - - - - - - - - - - - - - - - - - - - - - - - - -
import "jquery";
import "malihu-custom-scrollbar-plugin";
var $ = require("jquery");

if (window.matchMedia("(max-width: 767px)").matches) {
  $(function () {
    $(".header-menu").mCustomScrollbar({
      // horizontalScroll: false,
      scrollInertia: 0,
      set_width: "100%",
      theme: "light",
      mouseWheel: true,
      updateOnBrowserResize: true,
      autoHideScrollbar: false,
    });
  });
} else if (window.matchMedia("(min-width:768px)").matches) {
}

document.addEventListener("DOMContentLoaded", function () {});

window.addEventListener("DOMContentLoaded", () => {
  // new SimpleBar(document.querySelector(".news-wrap"), { autoHide: false });
  document.body.classList.add("loaded");
  // carousel
  // - - - - - - - - - - - - - - - - - - - - - - - - - -
  const swiper = new Swiper(".kv-carousel .swiper-container", {
    autoplay: {
      delay: 3000,
      loop: true,
    },
    speed: 1000,
    effect: "fade",
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true,
    },
  });
});

// header menu
// - - - - - - - - - - - - - - - - - - - - - - - - - -
const header = document.querySelector(".header");
document.querySelectorAll(".header-button, .nav-item").forEach((target) => {
  target.addEventListener("click", () => {
    header.classList.toggle("is-header-active");
    document.querySelector(".header-button").classList.toggle("is-active");
    document.querySelector(".header-menu").classList.toggle("is-active");
    lock.scrollLock();
  });
});

// image horizone scroll
// - - - - - - - - - - - - - - - - - - - - - - - - - -
const scrollArea = document.querySelectorAll(".js-scroll-alert");
// 検知
function createEventScrollX(ele) {
  this._past_scroll_left = 0;
  this.ev_scroll_x = new CustomEvent("scroll-x", {
    bubbles: true,
    cancelable: true,
  });
  this.dispatch_callback = function (ev) {
    var cuT = ev.currentTarget;
    var now_l = cuT.scrollLeft;
    if (now_l !== this.past_scroll_left) {
      ele.dispatchEvent(this.ev_scroll_x);
      this.past_scroll_left = now_l;
    }
  };

  var events = ["scroll", "touchmove"];
  events.forEach(
    function (ev, idx, arr) {
      ele.addEventListener(ev, this.dispatch_callback.bind(this), {
        capture: true,
        passive: true,
      });
    }.bind(this)
  );
}

for (let i = 0; i < scrollArea.length; i++) {
  var evX = new createEventScrollX(scrollArea[i]);
  scrollArea[i].addEventListener(
    "scroll-x",
    function (ev) {
      let target =
        ev.currentTarget.getElementsByClassName("js-touch-scroll")[0];
      target.classList.add("is-hidden");
    },
    { capture: true, passive: true }
  );
}

// smooth scroll
// - - - - - - - - - - - - - - - - - - - - - - - - - -
smoothscroll.polyfill();

const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
for (let i = 0; i < smoothScrollTrigger.length; i++) {
  smoothScrollTrigger[i].addEventListener("click", (e) => {
    e.preventDefault();
    let href = smoothScrollTrigger[i].getAttribute("href");
    let targetElement = document.getElementById(href.replace("#", ""));
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    const gap = 60;
    const target = rect + offset - gap;
    window.scrollTo({
      top: target,
      behavior: "smooth",
    });
  });
}
if (document.documentMode) {
  document.querySelector(`body`).addEventListener("mousewheel", (event) => {
    event.preventDefault();
    let wd = event.wheelDelta;
    let csp = window.pageYOffset;
    window.scrollTo(0, csp - wd);
  });
}

// modal
// - - - - - - - - - - - - - - - - - - - - - - - - - -
// modalを出す
const modalOpen = document.getElementsByClassName("modal-open");
const modal = document.getElementsByClassName("modal");
const modalCover = document.getElementsByClassName("modal-cover");

let modalCloseAction;
let dataModalOpen;
let selectModal;
let targetModal;

const TIMEOUT_SPEED = 500;

for (var i = 0; i < modalOpen.length; i++) {
  (function (n) {
    //モーダルを下げる
    modalCloseAction = function (e) {
      targetModal = e.currentTarget.closest(".modal");
      targetModal.classList.add("is-close");

      setTimeout(function (e) {
        targetModal.classList.remove("is-open");
        targetModal.classList.remove("is-close");
      }, TIMEOUT_SPEED);
    };

    // グレー部分をクリックでmodalを下げる
    const modalWrapClose = function () {
      for (var a = 0; a < modalOpen.length; a++) {
        (function (b) {
          modalCover[b].addEventListener(
            "click",
            function (e) {
              if (e.currentTarget.classList.contains("modal-cover")) {
                modalCloseAction(e);
              }
            },
            false
          );
        })(a);
      }
    };

    // modalをあげる
    const modalWrapOpen = function (e) {
      dataModalOpen = e.currentTarget.getAttribute("data-modal-open");
      for (var a = 0; a < modal.length; a++) {
        if (modal[a].getAttribute("data-modal") === dataModalOpen) {
          modal[a].classList.add("is-open");
          // lock.scrollLock()
          modalWrapClose();
          return false;
        }
      }
    };

    modalOpen[n].addEventListener(
      "click",
      function (e) {
        modalWrapOpen(e);
      },
      false
    );
  })(i);
}

// modalを下げる
const modalBtnClose = document.querySelectorAll(".modal-close");
for (var i = 0; i < modalBtnClose.length; i++) {
  (function (n) {
    modalBtnClose[n].addEventListener(
      "click",
      function (e) {
        modalCloseAction(e);
        return false;
      },
      false
    );
  })(i);
}
// header bg
// - - - - - - - - - - - - - - - - - - - - - - - - - -
gsap.to(header, {
  scrollTrigger: {
    trigger: ".section-kv",
    start: "bottom center",
    endTrigger: ".footer",
    // scroller: ".container__inner",
    toggleClass: {
      targets: ".header",
      className: "header-bg",
    },
  },
});

// key visual
// - - - - - - - - - - - - - - - - - - - - - - - - - -
const kvLetter = document.querySelectorAll(".step-letter");
gsap.to(kvLetter, {
  delay: 1,
  duration: 1,
  x: 0,
  opacity: 1,
  ease: "power2.out",
  // 複数要素を扱うプロパティ
  stagger: {
    from: "start", //左側から
    amount: 1, // 0.8秒おきに
  },
});
gsap.to(".earth-explane", {
  delay: 2,
  duration: 2,
  y: 0,
  opacity: 1,
  ease: "power2.out",
});

// key visual
// - - - - - - - - - - - - - - - - - - - - - - - - - -

const animTarget = document.querySelectorAll(".animItem");
animTarget.forEach((item, index) => {
  gsap.to(item, {
    scrollTrigger: {
      trigger: item,
      start: "top 85%",
      once: true,
      toggleClass: {
        targets: item,
        className: "is-visible",
      },
      stagger: 0.3,
    },
  });
});

const spanWrapText = (target) => {
  const nodes = [...target.childNodes]; // ノードリストを配列にする
  let returnText = ""; // 最終的に返すテキスト

  for (const node of nodes) {
    if (node.nodeType == 3) {
      //テキストの場合
      const text = node.textContent.replace(/\r?\n/g, ""); //テキストから改行コード削除
      const splitText = text.split(""); // 一文字ずつ分割
      for (const char of splitText) {
        returnText += `<span>${char}</span>`; // spanタグで挟んで連結
      }
    } else {
      //テキスト以外の場合
      //<br>などテキスト以外の要素をそのまま連結
      returnText += node.outerHTML;
    }
  }
  return returnText;
};
const animLetters = document.querySelectorAll(".anim-letter");
for (const letter of animLetters) {
  letter.innerHTML = spanWrapText(letter);
  letter.spans = letter.querySelectorAll("span");
}

const animLettersSet = {
  display: "inline-block",
  overflow: "hidden",
  opacity: 0,
  x: -20,
  duration: 0.8,
  ease: "power2.out",
};
const animLettersTo = {
  opacity: 1,
  x: 0,
  stagger: 0.03,
};
animLetters.forEach((item, index) => {
  const child = item.getElementsByTagName("span");
  gsap.set(child, animLettersSet);
  gsap.to(child, {
    ...animLettersTo,
    scrollTrigger: {
      trigger: item,
      // scroller: ".container__inner",
      start: "top 85%",
      // markers: true,
    },
  });
});
const animTitle = document.querySelectorAll(".anim-title");

const animTitleSet = {
  overflow: "hidden",
  opacity: 0,
  y: 20,
  duration: 0.6,
  ease: "power2.out",
};
const animTitleTo = {
  opacity: 1,
  y: 0,
};
animTitle.forEach((item, index) => {
  gsap.set(item, animTitleSet);
  gsap.to(item, {
    ...animTitleTo,
    scrollTrigger: {
      trigger: item,
      start: "top 90%",
    },
  });
});
